import React from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";
import { Margin, Padding } from "styled-components-spacing";
import { StaticImage } from "gatsby-plugin-image";
import { graphql, StaticQuery } from "gatsby";
import Heading from "@nib-components/heading";
import { Stack, Inline } from "@nib/layout";
import Link from "@nib-components/link";
import styled from "styled-components";
import Logo from "@nib-components/logo";
import Copy from "@nib-components/copy";

import nourishLogo from "./images/nourish_baby.webp";

const StyledLogo = styled(Logo)`
  width: 98px;
`;

const Text = ({ text, type }) => {
  if (type === "heading")
    return (
      <Margin top={{ xs: 4 }}>
        <Copy large measure={false}>
          <ReactMarkdown
            components={{
              // eslint-disable-next-line react/display-name
              a: ({ node, ...props }) => <Link {...props} target="_blank" rel="noopener"></Link>,
            }}
          >
            {text}
          </ReactMarkdown>
        </Copy>
      </Margin>
    );

  return (
    <Margin top={{ xs: 5 }}>
      <ReactMarkdown>{text}</ReactMarkdown>
    </Margin>
  );
};

const HeadingWithLinkOffset = styled(Heading)`
  &:target:before {
    content: "";
    display: block;
    height: 100px;
    margin: -100px 0 0;
  }
`;

const TermsAndConditions = (props) => {
  return (
    <StaticQuery
      query={graphql`
        query getNourishBaby {
          legalYaml(context: { eq: "nourish-baby" }) {
            content {
              text
              type
            }
          }
        }
      `}
      render={({ legalYaml: { content } }) => {
        return (
          <Stack space={{ xs: 2, md: 4 }}>
            <Padding vertical={{ xs: 5 }}>
              <HeadingWithLinkOffset id="contributors" component="h2" size={{ xs: 3, md: 2 }}>
                Where does the course content come from?
              </HeadingWithLinkOffset>
            </Padding>
            <Inline space={{ xs: 4, md: 4 }} verticalAlign="center">
              <StyledLogo size="medium" />
              <img src={nourishLogo} alt="nourish baby logo" />
            </Inline>
            {content.map((item, index) => {
              return <Text key={index} {...item} />;
            })}
          </Stack>
        );
      }}
    />
  );
};

Text.propTypes = {
  text: PropTypes.string,
  type: PropTypes.string,
};

export default TermsAndConditions;
